import React, { useEffect, useState } from "react";
import pkgbg from "../../Assets/images/pkgbg.png";
import py1 from "../../Assets/images/pymnt1.png";
import py2 from "../../Assets/images/pymnt2.png";
import { Markup } from "interweave";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../../config";
import { logout, setloading } from "../../Redux/ActionCreater";
import { useDispatch } from "react-redux";
const PackageCards = ({ data }) => {
  let navigation = useNavigate();
  let [active, setActive] = useState("");
  let [currentid, setCurrentid] = useState("");
  let [disable, setDisable] = useState(false);
  let dispatch = useDispatch();
  let subscribed = async (e, id) => {
    try {
      e.preventDefault();
      let token = localStorage.getItem("token");
      if (!token) {
        return toast.warning("Du musst dich einloggen, um fortzufahren. ");
      } else {
        if (active === "") {
          return toast.error("Bitte wähle eine Zahlart.");
        }
        setDisable(true);
        await axios
          .post(
            `${BASE_URL}/user/purchase-package`,
            { package_id: currentid, payment_type: active },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((res) => {
            if (res.data.responseCode === 1) {
              // toast.success(res.data.responseText);paymentLink
              // navigation('/subscription-thankyou');
              window.location.href = res.data.paymentLink;
            } else {
              toast.warning(res.data.responseText);
            }
            setDisable(false);
          });
      }
    } catch (error) {
      console.log(error);
      // dispatch(setloading(false));
      if (error.response.status === 401) {
        dispatch(
          logout(navigation, "Du musst dich einloggen, um fortzufahren. ")
        );
      } else {
        toast.error(error.response.data.message);
      }
    }
  };
  let freeSub = async (e, id) => {
    try {
      e.preventDefault();
      let token = localStorage.getItem("token");
      if (!token) {
        return toast.warning("Du musst dich einloggen, um fortzufahren. ");
      }
      await axios
        .post(
          `${BASE_URL}/user/free-subscription`,
          {},
          {
            headers: {
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.responseCode === 1) {
            toast.success(res.data.responseText);
            navigation("/subscription-thankyou");
          } else {
            toast.warning(res.data.responseText);
          }
        });
    } catch (error) {
      console.log(error);
      dispatch(setloading(false));
      if (error.response.status === 401) {
        dispatch(
          logout(navigation, "Du musst dich einloggen, um fortzufahren. ")
        );
      } else {
        toast.error(error.response.data.message);
      }
    }
  };
  // useEffect(() => {
  //   // Open the modal on page load

  // }, []);

  return (
    
    <section className="packages">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div
              className="sectionTitle text-center"
              data-aos="fade-up"
              data-aos-duration={5000}
            >
              <strong>Deine Fitness Pakete</strong>
            </div>
          </div>
        </div>
        {/*<div className="row">
          <div className="bgTextWrapper">
            <h2>Unsere
              Pakete</h2>
          </div>
        </div>*/}
        <div className='packegLst mt-4 mt-md-0'>
          <div className="row justify-content-center">
            {data &&
              data.length > 0 &&
              data.map((item, idx) => {
                return <div className="col-sm-12 col-lg-4 mb-4">
                  <div className="packageItem" data-aos="flip-left" data-aos-delay={500 * (idx + 1)}>
                    <form action>
                      <div className="packageName">
                        {item.package_name}
                        {item.save_percentage != 0 && (
                          <div className={"percentagebx discount" + (idx + 1)}>
                            <div className="w-100 text-center">
                              <span className="numtext">{item.save_percentage}<span>%</span></span>
                              <p>Rabatt</p>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="packageHead">
                        <strong>{item.price}€</strong><small>/{item.duration > 30 ? "Monat  " : "Monat"}</small>
                         <p><Markup content={item.short_description} /></p>
                      </div>
                      <div className="packageBody">
                        <h2>Deine Vorteile:</h2>
                        <Markup content={item.description} />
                        {/* <b>Grundfunktionen:</b>
                            <ul>
                              <li><i className="fa-regular fa-circle-check" /> <span>Fusce pellentesque metus</span></li>
                              <li><i className="fa-regular fa-circle-check" /> <span>Praesent ex orci</span></li>
                              <li><i className="fa-regular fa-circle-xmark" /> <span>Etiam semper tellus nec enim</span></li>
                              <li><i className="fa-regular fa-circle-xmark" /> <span>Fusce pellentesque metus</span></li>
                              <li><i className="fa-regular fa-circle-xmark" /> <span>Praesent ex orci</span></li>
                            </ul> */}
                      </div>
                      <span className="btnWrapper"><Link to={`/package-checkout/${item.id}`} className={"btn themeBTn btn" + (idx + 1)}>JETZT DURCHSTARTEN</Link></span>
                    </form>
                  </div>
                </div>
              })}

            <div className="col-sm-12 packagebtnbottom">
              <span className="btnWrapper"><Link to={"/packages"} data-bs-toggle="modal"
                          data-bs-target="#choosePackage" className="btn themeBTn btnBlack">Jetzt 7 Tage kostenlos testen</Link></span>
            </div>
            {/* <small className='mt-3 text-center'>*Die Mitgliedschaft verlängert sich automatisch. Danach ist sie mit einer Frist von einem Monat jederzeit kündbar.</small> */}
            <small className='mt-3 text-center'>*Die Mitgliedschaften verlängern sich automatisch. Nach Ablauf des Jahresabos erfolgt die Verlängerung zum regulären Monatspreis von 24,99 €. Danach können beide Mitgliedschaften jederzeit mit einer Frist von einem Monat gekündigt werden.</small>
            {/* <small className='mt-2 text-center'>**Coming soon</small> */}
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Payment Option
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="pyment-option">
                <div
                  className={
                    active === "paypal" ? "pymtnchoose activpay" : "pymtnchoose"
                  }
                  onClick={() => {
                    setActive("paypal");
                  }}
                >
                  <img src={py1} />
                </div>
                <div
                  className={
                    active === "stripe" ? "pymtnchoose activpay" : "pymtnchoose"
                  }
                  onClick={() => {
                    setActive("stripe");
                  }}
                >
                  <img src={py2} />
                </div>
              </div>
              <div className="confirm-pay">
                <Link
                  onClick={(e) => {
                    subscribed(e);
                  }}
                  disabled={disable}
                >
                  {/* Confirm Pay */}
                  {!disable ? (
                    "Bestätigen Sie die Zahlung"
                  ) : (
                    <span id="loading">
                      <span>&bull;</span>
                      <span>&bull;</span>
                      <span>&bull;</span>
                    </span>
                  )}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade packagemodal packagepkmodal"
        id="choosePackage"
        tabindex="-1"
        aria-labelledby="choosePackageLabel"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="choosePackageLabel">
                Wähle dein Paket:
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="packegLst">
                <div className="row justify-content-center">
                  {data &&
                    data.length > 0 &&
                    data.map((item, idx) => {
                      return (
                        <div className="col-sm-12 col-lg-4 mb-4">
                          <div
                            className="packageItem"
                            data-aos="flip-left"
                            data-aos-delay={500 * (idx + 1)}
                          >
                            <form action>
                              <div className="packageName">
                                {item.package_name}
                                 {item.save_percentage != 0 && (
                          <div className={"percentagebx discount" + (idx + 1)}>
                            <div className="w-100 text-center">
                              <span className="numtext">{item.save_percentage}<span>%</span></span>
                              <p>Rabatt</p>
                            </div>
                          </div>
                        )}
                              </div>
                              <div className="packageHead">
                                <strong>{item.price}€</strong>
                                <small>
                                  /{item.duration > 30 ? "Monat" : "Monat"}
                                </small>
                                 <p><Markup content={item.short_description} /></p>
                              </div>
                              <div className="packageBody">
                                <h2>Deine Vorteile:</h2>
                                <Markup content={item.description} />
                                {/* <b>Grundfunktionen:</b>
                        <ul>
                          <li><i className="fa-regular fa-circle-check" /> <span>Fusce pellentesque metus</span></li>
                          <li><i className="fa-regular fa-circle-check" /> <span>Praesent ex orci</span></li>
                          <li><i className="fa-regular fa-circle-xmark" /> <span>Etiam semper tellus nec enim</span></li>
                          <li><i className="fa-regular fa-circle-xmark" /> <span>Fusce pellentesque metus</span></li>
                          <li><i className="fa-regular fa-circle-xmark" /> <span>Praesent ex orci</span></li>
                        </ul> */}
                              </div>
                              <span className="btnWrapper">
                                <Link
                                  to={`/package-checkout/${item.id}?trial=true`}
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                  className={"btn themeBTn btn" + (idx + 1)}
                                  // data-bs-toggle="modal"
                                  // oc
                                  // data-bs-target="#exampleModal"
                                  onClick={() => {
                                    navigation(
                                      `/package-checkout/${item.id}?trial=true`
                                    );
                                  }}
                                >
                                  JETZT DURCHSTARTEN
                                </Link>
                                {/* <Link to={"/packages"} className={"btn themeBTn btn"+(idx+1)}>packages</Link> */}
                              </span>
                            </form>
                          </div>
                        </div>
                      );
                    })}

                  {/* <div className="col-sm-12">
                    <span className="btnWrapper btnGreyWrapper">
                      <Link to={"/packages"} className="btn themeBTn btnBlack">
                        Jetzt 7 Tage kostenlos testen
                      </Link>
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackageCards;
